import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/codefile';

const namespace = 'EVENTS';

export const CODEFILES_FETCH_START = `${namespace}/CODEFILES_FETCH_START`;
export const CODEFILES_FETCH_SUCCESS = `${namespace}/CODEFILES_FETCH_SUCCESS`;
export const CODEFILES_FETCH_ERROR = `${namespace}/CODEFILES_FETCH_ERROR`;

export const CODEFILE_SUMMARY_FETCH_START = `${namespace}/CODEFILE_SUMMARY_FETCH_START`;
export const CODEFILE_SUMMARY_FETCH_SUCCESS = `${namespace}/CODEFILE_SUMMARY_FETCH_SUCCESS`;
export const CODEFILE_SUMMARY_FETCH_ERROR = `${namespace}/CODEFILE_SUMMARY_FETCH_ERROR`;

export const CREATE_CODEFILE_START = `${namespace}/CREATE_CODEFILE_START`;
export const CREATE_CODEFILE_SUCCESS = `${namespace}/CREATE_CODEFILE_SUCCESS`;
export const CREATE_CODEFILE_ERROR = `${namespace}/CREATE_CODEFILE_ERROR`;

export const UPDATE_CODEFILE_START = `${namespace}/UPDATE_CODEFILE_START`;
export const UPDATE_CODEFILE_SUCCESS = `${namespace}/UPDATE_CODEFILE_SUCCESS`;
export const UPDATE_CODEFILE_ERROR = `${namespace}/UPDATE_CODEFILE_ERROR`;

export const DELETE_CODEFILE_START = `${namespace}/DELETE_CODEFILE_START`;
export const DELETE_CODEFILE_SUCCESS = `${namespace}/DELETE_CODEFILE_SUCCESS`;
export const DELETE_CODEFILE_ERROR = `${namespace}/DELETE_CODEFILE_ERROR`;

export const UPDATE_CODEFILE_FILTER = `${namespace}/UPDATE_CODEFILE_FILTER`;

export const fetchCodefiles = makeApiActionCreatorV3(
  api.fetchCodefiles,
  CODEFILES_FETCH_START,
  CODEFILES_FETCH_SUCCESS,
  CODEFILES_FETCH_ERROR,
);

export const fetchCodefileSummary = makeApiActionCreatorV3(
  api.fetchCodefileSummary,
  CODEFILE_SUMMARY_FETCH_START,
  CODEFILE_SUMMARY_FETCH_SUCCESS,
  CODEFILE_SUMMARY_FETCH_ERROR,
);

export const createCodefile = makeApiActionCreatorV3(
  api.createCodefile,
  CREATE_CODEFILE_START,
  CREATE_CODEFILE_SUCCESS,
  CREATE_CODEFILE_ERROR,
);

export const updateCodefile = makeApiActionCreatorV3(
  api.updateCodefile,
  UPDATE_CODEFILE_START,
  UPDATE_CODEFILE_SUCCESS,
  UPDATE_CODEFILE_ERROR,
);

export const deleteCodefile = makeApiActionCreatorV3(
  api.deleteCodefile,
  DELETE_CODEFILE_START,
  DELETE_CODEFILE_SUCCESS,
  DELETE_CODEFILE_ERROR,
);

export const updateFilter = (filter, value) => ({
  type: UPDATE_CODEFILE_FILTER,
  payload: { filter, value },
});
